import { createLazyFileRoute, useNavigate } from "@tanstack/react-router";
import { memo, useRef } from "react";
import { useTitle } from "react-use";

import { AccessionForm } from "@/features/accession/components/form-new/AccessionForm";
import { AdditionalSection } from "@/features/accession/components/form-new/AdditionalSection";
import { FooterSection } from "@/features/accession/components/form-new/FooterSection";
import { OrgSection } from "@/features/accession/components/form-new/OrgSection";
import { SamplesSection } from "@/features/accession/components/form-new/SampleSection";
import { TestsSection } from "@/features/accession/components/form-new/TestSection";

export const Route = createLazyFileRoute("/_auth/_app/subjects/$id/create")({
  component: memo(() => {
    useTitle("Create accession");

    const { id } = Route.useParams();
    const navigate = useNavigate();
    const orgId = Route.useLoaderData({ select: (s) => s.orgId });

    const containerRef = useRef<HTMLDivElement>(null);

    return (
      <div className="w-full flex-1 overflow-auto relative" ref={containerRef}>
        <div className="w-full max-w-3xl mx-auto p-6">
          <AccessionForm
            subjectId={id}
            orgId={orgId}
            containerRef={containerRef}
            onCreated={(accessionId) => {
              navigate({
                to: "/subjects/$id/accession",
                params: { id },
                search: (prev) => ({ ...prev, accessionId }),
              });
            }}
          >
            <OrgSection />
            <TestsSection />
            <SamplesSection />
            <AdditionalSection />
            <FooterSection />
          </AccessionForm>
        </div>
      </div>
    );
  }),
});
